import { TableCell } from "@mui/material";
import { useState } from "react";
import { toast } from "react-toastify";
import { Button, Modal } from "src/Components";
import FullScreenLoading from "src/Components/Loading/FullScreenLoading";
import {
  ApplyOptionPlanStatus,
  ApplyOptionsLastRequestStatus,
  IApplyPlanTableReport,
} from "src/Interfaces/applyOption";
import {
  getSubmitRequestsTable,
  manualSendPlanRow,
  manualSendPlanRowBulk,
} from "src/Requests/applyOption";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import TableTemplate, {
  IAdditional,
  IAdditionalHeaderProps,
} from "src/Tables/TableTemplate/tableTemplate";
import { packetErrorHandler } from "src/Utils/requestUtils";

const AdditionalHeader: React.FC<IAdditionalHeaderProps> = ({
  selectedRowsIds,
  onAction,
}) => {
  const [loading, setLoading] = useState(false);

  const bulkSendHandler = () => {
    if (!selectedRowsIds || !selectedRowsIds.length) return;
    setLoading(true);
    manualSendPlanRowBulk(selectedRowsIds)
      .then((resp) => {
        onAction();
        if (!resp.data) toast.error(resp.msg);
        else toast.success(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <>
      <TableCell>
        {loading ? <FullScreenLoading /> : null}
        <Button
          onClick={bulkSendHandler}
          text="ارسال دستی گروهی"
          variant="contained"
          className="table-btn"
          disabled={loading || !selectedRowsIds || !selectedRowsIds.length}
        />
      </TableCell>
      <TableCell />
    </>
  );
};

const AdditionalCol: React.FC<{
  row: IApplyPlanTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const sendManual = () => {
    setLoading(true);
    manualSendPlanRow(row.id)
      .then((resp) => {
        onAction();
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <>
      <TableCell>
        <Button
          onClick={sendManual}
          text="ارسال دستی"
          variant="contained"
          className="table-btn"
          disabled={loading}
        />
      </TableCell>
      <TableCell>
        {isModalOpen ? (
          <Modal
            onClose={() => setIsModalOpen(false)}
            UI={
              <TableTemplate
                getDataTable={getSubmitRequestsTable}
                TableUI={({ reports }) => <CommonTableUI reports={reports} />}
                initialSearchParameters={{
                  planId: row.id,
                }}
              />
            }
          />
        ) : (
          <></>
        )}
        <Button
          onClick={() => setIsModalOpen(true)}
          text="لاگ وضعیت درخواست"
          variant="contained"
          className="table-btn"
          disabled={loading}
        />
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IApplyPlanTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
